/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {z} from 'zod';

import {conversationUser} from '../../modules/user/conversationUser';
import {userIdParams} from '../../modules/user/userIdParams';

export const updateDmsUserParams = userIdParams;

export type UpdateDmsUserParams = z.infer<typeof updateDmsUserParams>;

export const updateDmsUserBody = z.object({
  displayName: z
    .string()
    .min(1, 'Display name is required')
    .max(255, 'Display name cannot exceed 255 characters'),
});

export type UpdateDmsUserBody = z.infer<typeof updateDmsUserBody>;

export const updateDmsUserResponse = conversationUser.omit({type: true}).extend({
  type: z.literal('DMS').openapi({
    description: 'Type of user',
    example: 'DMS',
  }),
});

export type UpdateDmsUserResponse = z.infer<typeof updateDmsUserResponse>;
